import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class DeviceStatusRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param siteId
   * @param type
   */
  get(siteId: number) {
    // let url = this.network.CodaQApi() + CQWebappApi.DEVICE_LIST;
    let url = 'https://service.codaq.it/cqdevicestatus/get';

    const headers = new HttpHeaders().append(
      RequestField.SITE_ID,
      siteId.toString(),
    );

    return this.network.http().put(url, null, { headers });
  }
}
